import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { usePreAuthDrawCtx } from '../../../../providers/PreAuthDrawProvider';
import { PaymentType } from '../../types';

export const AddPaymentMethodTitle: FC = () => {
  const drawController = usePreAuthDrawCtx();
  const { t } = useTranslation('product');

  if (drawController.selectedPaymentType === PaymentType.CRYPTO) {
    return t('drawers.review.draw.paymentMethod.addPaymentMethod.crypto.title');
  }
  return t('drawers.review.draw.paymentMethod.addPaymentMethod.title');
};
